import { render, staticRenderFns } from "./EipHotTable.vue?vue&type=template&id=72fa3711&scoped=true&"
import script from "./EipHotTable.vue?vue&type=script&lang=js&"
export * from "./EipHotTable.vue?vue&type=script&lang=js&"
import style0 from "./EipHotTable.vue?vue&type=style&index=0&id=72fa3711&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fa3711",
  null
  
)

export default component.exports